<template>
  <div v-if="isSupport" class="menu">
    <li class="list-group-item" v-on:click="isMenuOpened = !isMenuOpened">
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/apri.svg'" alt="app_print" align="middle">
      <LabelFunMessage fcontId="0" msgkey="121" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>
    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <h4 class="app_in">
          <LabelFunMessage fcontId="138" msgkey="47" />
        </h4>
        <p class="text-center">
          <AppCompatiblePrinters appName="nenga" />
        </p>

        <div class="text-center">
          <div class="app_icon_p">
            <img :src="app_root + '/assets/common/img/printlink/colorionenga.png'" />
          </div>
          <div class="app_badge">
            <p class="app_title">
              <LabelFunMessage fcontId="0" msgkey="175" />
            </p>

            <a
              v-on:click="trackGa4AppDownloadEvent()"
              :href="dynamicURL_Apple"
              target="itunes_store"
            >
              <img
                :src="app_root + '/assets/common/img/button/Download_on_the_App_Store_Badge_US-UK_135x40.svg'"
                class="app_store"
              />
            </a>
            <a
              v-on:click="trackGa4AppDownloadEvent()"
              :href="dynamicURL_Google"
              target="_blank"
            >
              <img
                :src="app_root + '/assets/common/img/button/google-play-badge.png'"
                class="google_play"
              />
            </a>

            <p class="dl_site">
              <span class="glyphicon glyphicon-info-sign"></span>
              <LabelFunMessage fcontId="0" msgkey="12" />
            </p>
          </div>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import AppCompatiblePrinters from "./AppCompatiblePrinters";
import { CONTENT_TYPE } from "@/common/contentsinfo";
import { Collapse } from "uiv";

export default {
  name: "PrintMenuColorioNenga",
  components: {
    LabelFunMessage,
    AppCompatiblePrinters,
    Collapse
  },
  props: {
    launchType: String, // select, print
    contentType: String, // designPaper, photoLayout, nenga など
    categoryId: String, // カラリオ年賀では未使用
    designId: String, // カラリオ年賀では未使用
    mediaSizeId: String, // カラリオ年賀では未使用
    mediaTypeId: String, // カラリオ年賀では未使用
    fcontId: String,
  },
  data() {
    return {
      isMenuOpened: true,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    ...mapState(["os"]),
    isMobile: function () {
      return this.os == "ios" || this.os == "ard";
    },
    isSupport: function () {
      if (this.isMobile) {
        switch (this.contentType) {
          case CONTENT_TYPE.nenga:
          case CONTENT_TYPE.postcard:
          case CONTENT_TYPE.mochu:
            return true;
          case CONTENT_TYPE.designpaper:
          case CONTENT_TYPE.photoLayout:
          case CONTENT_TYPE.freeLayout:
          case CONTENT_TYPE.greetingCards:
          case CONTENT_TYPE.designpaperPremiumCollection:
          case CONTENT_TYPE.photobook:
          case CONTENT_TYPE.album:
          case CONTENT_TYPE.createplusContents:
          case CONTENT_TYPE.creativeTop:
          default:
            return false;
        }
      }
      return false;
    },
    dynamicURL_Apple() {
      return `https://apps.apple.com/jp/app/id1039733739?pt=280580&ct=fcont_${this.fcontId}&mt=8`;
    },
    dynamicURL_Google() {
      return `https://play.google.com/store/apps/details?id=com.epson.nenga&utm_source=gallery&utm_campaign=fcont_${this.fcontId}&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1
`;
    },

  },
  methods: {
    trackGa4AppDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Colorio Nenga",
        "location_id": "printButton",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })

    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h4.app_in {
  margin-top: 10px;
  font-size: 16px;
}

.app_icon_p img {
  margin-top: 10px;
  width: 100px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  h4.app_in {
    font-size: 14px;
  }
}
</style>